import { render } from "./myProfile.vue?vue&type=template&id=ee7a8656&scoped=true"
import script from "./myProfile.vue?vue&type=script&lang=js"
export * from "./myProfile.vue?vue&type=script&lang=js"

import "./myProfile.vue?vue&type=style&index=0&id=ee7a8656&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee7a8656"]])

export default __exports__